import {RectNode, RectNodeModel, h} from '@logicflow/core';
import {resolveExecStyle, EXEC_STATUS} from '../../../exec-status';

function hasClonedBy(properties = {}) {
  const v = properties.clonedBy;
  if (!v) {
    return false;
  }
  if (typeof v === 'string') {
    return !!v;
  }
  return !!(v.key);
}

class CarbonNode extends RectNode {
  getShape() {
    const {model} = this.props;
    const {x, y, width, height, properties} = model;
    let approvalName = '抄送人';
    if (Array.isArray(properties.users)) {
      approvalName = ' ' + properties.users.map((v) => v.name);
    }

    const left = x - width / 2;
    const top = y - height / 2;
    const isClone = hasClonedBy(properties);
    const colors = resolveExecStyle(properties, {
      fill: '#E6F7FF',
      stroke: '#1890FF',
      text: '#1890FF',
      icon: '#1890FF',
    });
    const doneColors = EXEC_STATUS.done;
    const partialDone = !!properties._clonePartialDone;

    const userIcon = h('svg', {
      x: left + 5,
      y: top + 5,
      width: 16,
      height: 16,
      viewBox: '0 0 1024 1024',
      fill: colors.icon,
    }, [
      h('path', {
        d: 'M512 512a256 256 0 1 0 0-512 256 256 0 0 0 0 512z m0 85.333333c-170.666667 0-512 85.333333-512 256v85.333334h1024v-85.333334c0-170.666667-341.333333-256-512-256z',
      }),
    ]);

    const text = h('text', {
      x: left + 25,
      y: top + 18,
      fill: colors.text,
      fontSize: 12,
      textAnchor: 'start',
    }, approvalName);

    const doms = [];

    if (isClone) {
      const stackOffsets = [
        {dx: 10, dy: -10, fill: '#F0F5FF', stroke: '#91D5FF', opacity: 0.85},
        {dx: 5, dy: -5, fill: '#E6F7FF', stroke: '#69C0FF', opacity: 0.95},
      ];
      stackOffsets.forEach((s, i) => {
        const useDone = partialDone && i === 0;
        doms.push(h('rect', {
          x: left + s.dx,
          y: top + s.dy,
          width,
          height,
          fill: useDone ? doneColors.fill : s.fill,
          stroke: useDone ? doneColors.stroke :
            (colors.stroke === '#BFBFBF' ? s.stroke : colors.stroke),
          strokeWidth: 1.5,
          rx: 10,
          ry: 10,
          opacity: s.opacity,
        }));
      });
    }

    doms.push(h('rect', {
      x: left,
      y: top,
      width,
      height,
      fill: colors.fill,
      stroke: colors.stroke,
      strokeWidth: 2,
      rx: 10,
      ry: 10,
    }));
    doms.push(userIcon);
    doms.push(text);

    if (isClone) {
      const label = properties.clonedBy?.control?.name ||
        properties.clonedBy?.key ||
        properties.clonedKey ||
        '克隆';
      doms.push(h('text', {
        x: left + 8,
        y: top + height - 10,
        fill: '#52C41A',
        fontSize: 10,
        textAnchor: 'start',
      }, `× ${label}`));
    }

    return h('g', {}, doms);
  }
}

class CarbonNodeModel extends RectNodeModel {
  initNodeData(e) {
    super.initNodeData(e);
    this.width = 160;
    this.height = 80;
  }

  getProps() {
    return [{
      key: 'executor-type',
      label: '抄送人类型',
      control: 'Select',
      option: {
        options: ['发起人自选', '固定'],
      },
      group: '审批',
      desc: '发起人自选：发起时指定；固定：使用默认抄送人或范围',
    }, {
      key: 'executor-region',
      label: '抄送人范围',
      control: 'ACLSelect',
      group: '审批',
      desc: '可选抄送人的组织/角色范围限制',
    }, {
      key: 'multiple',
      label: '抄送人多选',
      control: 'Check',
      group: '审批',
      desc: '开启后该节点可选择多名抄送人',
    }, {
      key: 'default-users',
      label: '默认抄送人',
      control: 'UserSelect',
      group: '审批',
      desc: '未配置克隆时的默认抄送人；有克隆对象时请用「分类默认人」',
    }, {
      key: 'clonedDefaultUsers',
      label: '分类默认人',
      control: 'CloneDefaultUsers',
      group: '审批',
      desc: '为每个克隆分类配置默认抄送人',
    }, {
      key: 'message',
      label: '短信通知',
      control: 'Check',
      group: '通知',
      desc: '到达本节点时是否发送短信提醒',
    }, {
      key: 'clonedBy',
      label: '克隆对象',
      control: 'FieldSelect',
      group: '高级',
      desc: '按表单中某个数组字段拆成多个并行抄送线程，每个取值一条',
    }, {
      key: 'parallelVisible',
      label: '平行可见',
      control: 'Check',
      group: '高级',
      desc: '关闭时只看到自己的克隆线程；开启后可查看平行线程',
    }, {
      key: 'independentExecutors',
      label: '独立负责人',
      control: 'Check',
      group: '高级',
      desc: '各克隆分类使用独立抄送人，不与同克隆对象的其它节点自动同步',
    }, {
      key: 'clonedType',
      label: '克隆类型',
      control: 'Select',
      option: {
        options: ['文本', '部门', '成员'],
        defaultTo: '文本',
      },
      group: '高级',
      desc: '克隆项的展示与解析类型，影响分类名称和默认人匹配',
    }];
  }

  setAllowLinkOut() {
    return false;
  }
}

export default {
  type: 'carbon_node',
  view: CarbonNode,
  model: CarbonNodeModel,
};
